import React from "react";
import { Partners } from "../../../comps/data";
import "../../../style/slider.css";

export default function Slider() {
  return (
    <div className="mt-12">
      <div className="mb-8">
        <h1 className="max-w-[1200px text-center mx-auto font-bold md:text-5xl text-3xl">Trusted by Industry Leaders</h1>
      </div>

      <div className="slider">
        <ul className="" aria-hidden="true">
          {Partners.map((partner, i) => {
            return (
              <li>
                <img src={partner.image} alt="" />
              </li>
            );
          })}
        </ul>
        <ul className="" aria-hidden="true">
          {Partners.map((partner, i) => {
            return (
              <li>
                <img src={partner.image} alt="" />
              </li>
            );
          })}
        </ul>Trusted by Industry Leaders
        <ul className="" aria-hidden="true">
          {Partners.map((partner, i) => {
            return (
              <li>
                <img src={partner.image} alt="" />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
